// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0a0e14;
  --bg-elevated: #0f1419;
  --bg-card: #121820;
  --border: #1e2a3a;
  --border-hover: #2d3f54;
  --text: #e6edf3;
  --text-muted: #7d8b9a;
  --accent: #39d353;
  --accent-dim: #238636;
  --accent-glow: rgba(57, 211, 83, 0.15);
  --cyan: #58a6ff;
  --orange: #f0883e;
  --font-mono: 'JetBrains Mono', 'Consolas', monospace;
  --font-sans: 'Noto Sans SC', system-ui, sans-serif;
  --radius: 6px;
  --transition: 0.2s ease;
  --max-width: 1100px;
  --nav-height: 64px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,oDAAoD;EACpD,kDAAkD;EAClD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[":root {\r\n  --bg: #0a0e14;\r\n  --bg-elevated: #0f1419;\r\n  --bg-card: #121820;\r\n  --border: #1e2a3a;\r\n  --border-hover: #2d3f54;\r\n  --text: #e6edf3;\r\n  --text-muted: #7d8b9a;\r\n  --accent: #39d353;\r\n  --accent-dim: #238636;\r\n  --accent-glow: rgba(57, 211, 83, 0.15);\r\n  --cyan: #58a6ff;\r\n  --orange: #f0883e;\r\n  --font-mono: 'JetBrains Mono', 'Consolas', monospace;\r\n  --font-sans: 'Noto Sans SC', system-ui, sans-serif;\r\n  --radius: 6px;\r\n  --transition: 0.2s ease;\r\n  --max-width: 1100px;\r\n  --nav-height: 64px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
